export const image: CSSFunction<{ isEmptySearchResult: boolean }> =
  ({ cssProps: { isEmptySearchResult } }) => ({
  width: 120,
  height: 120,
  paddingBottom: isEmptySearchResult ? 8 : 0,
});
